import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=cc24469e&scoped=true&"
import script from "./Sign.vue?vue&type=script&lang=js&"
export * from "./Sign.vue?vue&type=script&lang=js&"
import style0 from "./Sign.vue?vue&type=style&index=0&id=cc24469e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc24469e",
  null
  
)

export default component.exports